import config from '../../config/config';

import getRequest from './base/get';

export default {
  /**
   * Get the profile details in api function
   * @returns
   */
  getProfileDetails: (): Promise<any> => {
    return getRequest(`${config.accountApiUrl}api/facility/v1/users/profile`);
  },
  /**
   * Get the total charging station function
   * @returns
   */
  getTotalChargingStation: (): Promise<any> => {
    return getRequest(
      `${config.commonApiUrl}api/facility/v1/charging-station/total-charging-stations`,
    );
  },
  /**
   * Get the total charging station function
   * @returns
   */
  getTotalChargingPoints: (): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-point/total-charging-points`);
  },
  /**
   * Get the total charging station function
   * @returns
   */
  getTotalConnectors: (): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-point/total-connectors`);
  },
  /**
   * Get revenue history
   */
  getRevenueHistory: (): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-transaction/cs-revenue-growth-month-wise`,
    );
  },
  /**
   * Get total balance
   */
  getTotalWalletBalance: (): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/facility/v1/charging-transaction/total-revenue`);
  },
};
